/* Theme fix (2026-10-18): the product gallery is re-rendered when the colour changes, but the theme binds its
   PhotoSwipe lightbox once at page load (assets/gallery.js). After a colour change, tapping a photo followed the
   raw image link (new tab / "download" on iPhone) instead of opening the zoom. This binds a lightbox to any gallery
   the original one doesn't handle. Same options as the theme. */
import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';

const bound = new WeakMap();
document.addEventListener('click', (e) => {
  if (e.defaultPrevented) return; // the theme's lightbox (or another handler) already took it
  const link = e.target.closest('.photoswipe a[data-pswp-width]');
  if (!link) return;
  const gallery = link.closest('.photoswipe');
  let lightbox = bound.get(gallery);
  if (!lightbox) {
    lightbox = new PhotoSwipeLightbox({ gallery, children: 'a', pswpModule: () => import('./photoswipe.esm.min.js'), bgOpacity: 1 });
    window.pdpmPswp?.decorate(lightbox); // PDP mobile v2 zoom options (assets/pdp-mobile.js), when present
    lightbox.init();
    bound.set(gallery, lightbox);
  }
  e.preventDefault();
  const items = [...gallery.querySelectorAll('a')];
  lightbox.loadAndOpen(Math.max(0, items.indexOf(link)), { gallery });
});
